import dashboard from './dashboard';
import learning from './learning';
import schedule from './schedule';
import program from './program';
import haunted from './haunted';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, haunted, schedule, learning, program]
};

export default menuItems;
